import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "form"]
  static values = {
    debounce: { type: Number, default: 250 }
  }

  connect() {
    this.handleGlobalKeydown = this.handleGlobalKeydown.bind(this)

    if (this.hasSearchTarget) {
      document.addEventListener("keydown", this.handleGlobalKeydown)
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleGlobalKeydown)
    clearTimeout(this.submitTimer)
  }

  queueSubmit() {
    clearTimeout(this.submitTimer)
    this.submitTimer = setTimeout(() => this.submit(), this.debounceValue)
  }

  submit() {
    clearTimeout(this.submitTimer)
    const form = this.form

    if (typeof form?.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form?.submit()
    }
  }

  clear() {
    if (!this.hasSearchTarget) return

    this.searchTarget.value = ""
    this.searchTarget.focus()
    this.submit()
  }

  handleGlobalKeydown(event) {
    if (event.key !== "/" || event.metaKey || event.ctrlKey || event.altKey) return
    if (!this.hasSearchTarget) return
    const target = event.target
    const tag = target?.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target?.isContentEditable) return

    event.preventDefault()
    this.searchTarget.focus()
    this.searchTarget.select()
  }

  get form() {
    if (this.hasFormTarget) return this.formTarget
    return this.element.tagName === "FORM" ? this.element : null
  }
}
